<template>
    <div class="bg p-3 pb-6">
        <div class="form-columns-fit mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(1)"
                        v-model="motivosAtendimentoSelected"
                        title="motivo"
                        label="descricao"
                        :options="motivosAtendimento"
                        :loading="motivosAtendimentoLoading"
                        @search="carregarMotivoAtendimento"
                        @input="updateValueMotivosAtendimento"
                        iconPosition="left"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-flex is-flex-hbetween">
                    <div class="column p-1">
                        <verified-date-picker
                            dateType="startDate"
                            :value="datainicial"
                            :endDate="datafinal"
                            title="data-inicio"
                            :showClean="false"
                            @input="updateDataAtendimento"
                            inForm
                            required
                            :invalid="datainicial == null"
                        />
                    </div>
                    <div class="column p-0">
                        <verified-date-picker
                            dateType="endDate"
                            :value="datafinal"
                            :startDate="datainicial"
                            title="data-fim"
                            :addDateYears="2"
                            :showClean="false"
                            @input="updateDataFinalizacao"
                            inForm
                            required
                            :invalid="datafinal == null"
                        />
                    </div>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(4)"
                        title="cliente"
                        label="rsocial"
                        v-model="clienteSelected"
                        :options="clientes"
                        :loading="clientesLoading"
                        placeholder="placeholder-preencha"
                        @search="carregarClientes"
                        @input="updateValueCliente"
                        searchable
                        clearable
                        tooltipLabel="msg-atendimento-cliente"
                        tooltipPosition="is-bottom"
                        tooltipSize="is-large"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(6)"
                        title="propriedade"
                        label="nome"
                        v-model="propriedadeSelected"
                        :options="propriedades"
                        :loading="propriedadesLoading"
                        @search="carregarPropriedades"
                        @input="updateValuePropriedade"
                        :placeholder="!clienteSelected ? 'msg-selecione-cliente' : null"
                        :disabled="!clienteSelected"
                        searchable
                        clearable
                        tooltipLabel="msg-atendimento-propriedade"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(7)"
                        title="area"
                        label="descricao"
                        v-model="areaSelected"
                        :options="areas"
                        :loading="areasLoading"
                        @search="carregarAreas"
                        @input="updateValueArea"
                        :placeholder="!propriedadeSelected ? 'msg-selecione-propriedade' : null"
                        :disabled="!propriedadeSelected"
                        searchable
                        clearable
                        tooltipLabel="msg-atendimento-area"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(8)"
                        title="talhao"
                        label="descricao"
                        v-model="talhoesSelected"
                        :options="talhoes"
                        :loading="talhoesLoading"
                        @search="carregarTalhoes"
                        @input="updateValueTalhoes"
                        :disabled="!areaSelected"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(14)"
                        v-model="safrasSelected"
                        title="safra"
                        label="descricao"
                        :options="safras"
                        :loading="safrasLoading"
                        @search="carregarSafras"
                        @input="updateValueSafras"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(9)"
                        title="cultura"
                        label="descricao"
                        v-model="culturaSelected"
                        :options="culturas"
                        :loading="culturasLoading"
                        placeholder="placeholder-preencha"
                        @search="carregarCulturas"
                        @input="updateValueCultura"
                        searchable
                        clearable
                        tooltipLabel="msg-tooltip-cultura-selecionada"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(10)"
                        v-model="cultivaresSelected"
                        title="cultivar"
                        label="descricao"
                        :options="cultivares"
                        :loading="culturasLoading"
                        @search="carregarCultivares"
                        @input="updateValueCultivares"
                        :disabled="!culturaSelected"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(11)"
                        v-model="fasesFenologicasSelected"
                        title="agro-fasefenologica"
                        label="descricao"
                        :options="fasesFenologicas"
                        :loading="fasesFenologicasLoading"
                        @search="carregarFasesFenologicas"
                        @input="updateValueFasesFenologicas"
                        :disabled="!culturaSelected"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(12)"
                        v-model="tiposDeAgroVisitasSelected"
                        title="tipo-agro-visita"
                        label="descricao"
                        :options="tiposDeAgroVisitas"
                        :loading="tiposDeAgroVisitasLoading"
                        @search="carregarTiposAgroVisitas"
                        @input="updateValueTiposAgroVisitas"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(13)"
                        v-model="assuntosAgroVisitasSelected"
                        title="assunto-agro-visita"
                        label="descricao"
                        :options="assuntosAgroVisitas"
                        :loading="assuntosDaAgrovisitasLoading"
                        @search="carregarAssuntosAgroVisitas"
                        @input="updateValueAssuntosAgroVisitas"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>

                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(5)"
                        label="descricao"
                        title="funil"
                        v-model="funilSelected"
                        :options="funilList"
                        :loading="funilLoading"
                        placeholder="placeholder-preencha"
                        @search="carregarFunis"
                        @input="updateValueFunil"
                        searchable
                        clearable
                        tooltipLabel="msg-atendimento-etapa"
                        tooltipPosition="is-right"
                        tooltipSize="is-large"
                        tooltipMultilined
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(6)"
                        label="nome"
                        title="etapa"
                        v-model="etapaSelected"
                        :options="etapaList"
                        :loading="etapaLoading"
                        placeholder="placeholder-preencha"
                        @search="carregarEtapas"
                        @input="updateValueEtapa"
                        iconPosition="left"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoAtendimentoService from '@/services/MotivoAtendimentoService';
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import VendasClienteService from '@/services/VendasClienteService';
import FunilService from '@/services/FunilService';
import EtapaService from '@/services/EtapaService';
import FaseFenologicaService from '@/services/agro/FaseFenologicaService';
import SafraService from '@/services/agro/SafraService';
import PropriedadeService from '@/services/agro/PropriedadeService';
import AreaService from '@/services/agro/AreaService';
import TalhaoService from '@/services/agro/TalhaoService';
import AssuntoRtrService from '@/services/agro/AssuntoRtrService';
import TipoRtrService from '@/services/agro/TipoRtrService';
import CultivarService from '@/services/agro/CultivarService';
import CulturaService from '@/services/agro/CulturaService';

export default {
    props: {
        filtersReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            /********* services *********/

            empresaService: new EmpresaService(this.$http, this.$router),
            clienteService: new VendasClienteService(this.$http, this.$router),
            funilService: new FunilService(this.$http, this.$router),
            etapaService: new EtapaService(this.$http, this.$router),
            propriedadeService: new PropriedadeService(this.$http, this.$router),
            motivoService: new MotivoAtendimentoService(this.$http, this.$router),
            areaService: new AreaService(this.$http, this.$router),
            talhaoService: new TalhaoService(this.$http, this.$router),
            assuntoAgroVisitaService: new AssuntoRtrService(this.$http, this.$router),
            tipoAgroVisitaService: new TipoRtrService(this.$http, this.$router),
            cultivarService: new CultivarService(this.$http, this.$router),
            culturaService: new CulturaService(this.$http, this.$router),
            faseFenologicaService: new FaseFenologicaService(this.$http, this.$router),
            safraService: new SafraService(this.$http, this.$router),

            /********* dados *********/

            motivosAtendimento: [],
            motivosAtendimentoSelected: [],
            motivosAtendimentoLoading: false,

            datainicial: this.minusWeeks(new Date(), 4),
            datafinal: this.addWeeks(new Date(), 4),

            clientes: [],
            clienteSelected: null,
            clientesLoading: false,

            funilList: [],
            funilSelected: null,
            funilLoading: false,

            etapaList: [],
            etapaSelected: null,
            etapaLoading: false,

            propriedades: [],
            propriedadeSelected: null,
            propriedadesLoading: false,

            areas: [],
            areaSelected: null,
            areasLoading: false,

            talhoes: [],
            talhoesSelected: [],
            talhoesLoading: false,

            safras: [],
            safrasSelected: [],
            safrasLoading: false,

            culturas: [],
            culturaSelected: null,
            culturasLoading: false,

            cultivares: [],
            cultivaresSelected: [],
            cultivaresLoading: false,

            fasesFenologicas: [],
            fasesFenologicasSelected: [],
            fasesFenologicasLoading: false,

            tiposDeAgroVisitas: [],
            tiposDeAgroVisitasSelected: [],
            tiposDeAgroVisitasLoading: false,

            assuntosAgroVisitas: [],
            assuntosAgroVisitasSelected: [],
            assuntosDaAgrovisitasLoading: false,

            observacao: '',

            isEmpty: false,
            filterCompact: false,
        };
    },
    watch: {
        filtersReset(val) {
            if (val) this.clearFilter();
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        minusWeeks(date, weeks) {
            date.setDate(date.getDate() - 7 * weeks);
            return date;
        },
        addWeeks(date, weeks) {
            date.setDate(date.getDate() + 7 * weeks);
            return date;
        },
        /* Carregar componentes utilizados */
        carregarMotivoAtendimento(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.motivosAtendimentoLoading = true;

            this.motivoService
                .findAll('descricao', 'asc', 0, 20, 1, query)
                .then((r) => {
                    this.motivosAtendimento = r.content;
                })
                .catch((e) => {
                    this.motivosAtendimento = [];
                })
                .finally((_) => {
                    this.motivosAtendimentoLoading = false;
                });
        },
        carregarClientes(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.clientesLoading = true;

            this.clienteService
                .findAllCombo(query)
                .then((body) => {
                    this.clientes = Object.assign(body.content);
                })
                .catch((e) => {
                    this.clientes = [];
                })
                .finally((_) => {
                    this.carregarPropriedades();
                    this.clientesLoading = false;
                });
        },
        carregarFunis(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.funilLoading = true;

            this.funilService
                .findAllCombo(0, query)
                .then((r) => {
                    this.funilList = r.content;
                })
                .catch((e) => {
                    this.funilList = [];
                })
                .finally((_) => {
                    this.carregarEtapas();
                    this.funilLoading = false;
                });
        },
        carregarEtapas(query = '') {
            if (this.funilSelected && this.funilSelected.idFunil > 0) {
                query = this.isNull(query) ? '.*' : this.removeToSearch(query);
                this.etapasLoading = true;

                this.etapaService
                    .findAllCombo(this.funilSelected.idFunil, 2, query)
                    .then((body) => {
                        this.etapaList = Object.assign(body.content);
                    })
                    .catch((e) => {
                        this.etapaList = [];
                    })
                    .finally((_) => {
                        this.etapasLoading = false;
                    });
            }
        },
        carregarPropriedades(query = '') {
            if (this.clienteSelected && this.clienteSelected.idcliente > 0) {
                query = this.isNull(query) ? '.*' : this.removeToSearch(query);
                this.propriedadesLoading = true;

                this.propriedadeService
                    .listAllByIdCliente(this.clienteSelected.idcliente, 50, 0, query)
                    .then((value) => {
                        this.propriedades = value.content;
                    })
                    .catch((e) => {
                        this.propriedades = [];
                    })
                    .finally((_) => {
                        if (this.propriedades.length === 1 && !this.isUpdate) {
                            this.updateValuePropriedade(this.propriedades[0]);
                        }
                        this.carregarAreas();
                        this.propriedadesLoading = false;
                    });
            }
        },
        carregarAreas(query = '') {
            if (this.propriedadeSelected) {
                query = this.isNull(query) ? '.*' : this.removeToSearch(query);
                this.areasLoading = true;

                this.areaService
                    .findAllByPropriedade(this.propriedadeSelected.uuid, 20, query)
                    .then((r) => {
                        this.areas = r.content.map((e) => {
                            return {
                                idarea: e.idarea,
                                descricao: e.descricao,
                                id: e.id,
                                uuid: e.uuid,
                            };
                        });
                    })
                    .catch((e) => {
                        this.areas = [];
                    })
                    .finally((_) => {
                        if (this.areas.length === 1 && !this.isUpdate) {
                            this.updateValueArea(this.areas[0]);
                        }
                        this.carregarTalhoes();
                        this.areasLoading = false;
                    });
            }
        },
        carregarTalhoes(query = '') {
            if (this.areaSelected) {
                query = this.isNull(query) ? '.*' : this.removeToSearch(query);
                this.talhoesLoading = true;

                this.talhaoService
                    .findAllByArea(this.areaSelected.uuid, 20, query)
                    .then((r) => {
                        this.talhoes = r.content.map((e) => {
                            return {
                                idtalhao: e.idtalhao,
                                descricao: e.descricao,
                                id: e.id,
                                uuid: e.uuid,
                            };
                        });
                    })
                    .catch((e) => {
                        this.talhoes = [];
                    })
                    .finally((_) => {
                        this.talhoesLoading = false;
                    });
            }
        },
        carregarSafras(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.safrasLoading = true;

            this.safraService
                .findAllCombo(query)
                .then((value) => {
                    this.safras = value.content;
                })
                .catch((e) => {
                    this.safras = [];
                })
                .finally((_) => {
                    this.safrasLoading = false;
                });
        },
        carregarCulturas(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.culturasLoading = true;

            this.culturaService
                .findAllCombo(query)
                .then((r) => {
                    if (r.content != null) {
                        this.culturas = r.content.map((e) => {
                            return {
                                idtipocultura: e.idtipocultura,
                                descricao: e.descricao,
                                id: e.id,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.culturas = [];
                })
                .finally((_) => {
                    this.culturasLoading = false;
                });
        },
        carregarCultivares(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            if (this.culturaSelected && this.culturaSelected.id > 0) {
                this.cultivaresLoading = true;

                this.cultivarService
                    .findAllComboByIdCultura(1, this.culturaSelected.id, query)
                    .then((r) => {
                        if (r.content != null) {
                            this.cultivares = r.content.map((e) => {
                                return {
                                    idcultivar: e.idcultivar,
                                    descricao: e.descricao,
                                    id: e.id,
                                };
                            });
                        }
                    })
                    .catch((e) => {
                        this.cultivares = [];
                    })
                    .finally((_) => {
                        this.cultivaresLoading = false;
                    });
            }
        },
        carregarFasesFenologicas(query = '') {
            if (this.culturaSelected && this.culturaSelected.id > 0) {
                query = this.isNull(query) ? '.*' : this.removeToSearch(query);
                this.fasesFenologicasLoading = true;

                this.faseFenologicaService
                    .findAllComboByIdCultura(this.culturaSelected.id, query)
                    .then((r) => {
                        this.fasesFenologicas = r.content.map((e) => {
                            return {
                                idagrofasefenologica: e.agroFaseFenologica.idagrofasefenologica,
                                descricao: e.agroFaseFenologica.descricao,
                                id: e.agroFaseFenologica.id,
                            };
                        });
                    })
                    .catch((e) => {
                        this.fasesFenologicas = [];
                    })
                    .finally((_) => {
                        this.fasesFenologicasLoading = false;
                    });
            }
        },
        carregarTiposAgroVisitas(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.tiposDeAgroVisitasLoading = true;

            this.tipoAgroVisitaService
                .findAllCombo(query)
                .then((r) => {
                    this.tiposDeAgroVisitas = r.content.map((e) => {
                        return {
                            idtiportr: e.idtiportr,
                            descricao: e.descricao,
                            id: e.id,
                        };
                    });
                })
                .catch((e) => {
                    this.tiposDeAgroVisitas = [];
                })
                .finally((_) => {
                    this.tiposDeAgroVisitasLoading = false;
                });
        },
        carregarAssuntosAgroVisitas(query = '') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.assuntosDaAgrovisitasLoading = true;

            let idsTiposVisita = {};
            idsTiposVisita = this.tiposDeAgroVisitasSelected.map((e) => e.id);

            this.assuntoAgroVisitaService
                .listAllByMultipleIdsTipoVisita(idsTiposVisita, 1000, 0, 2, query)
                .then((r) => {
                    this.assuntosAgroVisitas = r.content.map((e) => {
                        return {
                            idassuntortr: e.idassuntortr,
                            descricao: e.descricao,
                            id: e.id,
                        };
                    });
                })
                .catch((e) => {
                    this.assuntosAgroVisitas = [];
                })
                .finally((_) => {
                    this.assuntosDaAgrovisitasLoading = false;
                });
        },

        /* Metodos que realizam a limpeza dos dados */
        clearFilter() {
            this.motivosAtendimentoSelected = [];
            this.clienteSelected = null;
            this.propriedadeSelected = null;
            this.areaSelected = null;
            this.talhoesSelected = [];
            this.safrasSelected = [];
            this.culturaSelected = null;
            this.cultivaresSelected = [];
            this.fasesFenologicasSelected = [];
            this.tiposDeAgroVisitasSelected = [];
            this.assuntosAgroVisitasSelected = [];
            this.datainicial = this.minusWeeks(new Date(), 4);
            this.datafinal = this.addWeeks(new Date(), 4);
            this.observacao = '';
        },
        updateValueMotivosAtendimento(motivosAtendimentoSelected) {
            this.motivosAtendimentoSelected = motivosAtendimentoSelected;

            this.$emit('update-filtro', {
                nomeFiltro: 'motivosAtendimento',
                valor:
                    this.motivosAtendimentoSelected.length == 0
                        ? []
                        : this.motivosAtendimentoSelected.map((e) => e.id),
            });
        },
        updateValueCliente(value) {
            this.clienteSelected = value;

            this.$emit('update-filtro', {
                nomeFiltro: 'cliente',
                valor: this.clienteSelected,
            });

            this.propriedadeSelected = null;
            this.areaSelected = null;
            this.talhoesSelected = [];

            this.propriedades = [];
            this.areas = [];
            this.talhoes = [];

            this.carregarPropriedades();
        },
        updateValueFunil(valor) {
            this.funilSelected = valor;

            this.$emit('update-filtro', {
                nomeFiltro: 'funil',
                valor: this.funilSelected,
            });

            this.etapaSelected = null;

            this.etapaList = [];

            this.carregarEtapas();
        },
        updateValueEtapa(valor) {
            this.etapaSelected = valor;

            this.$emit('update-filtro', {
                nomeFiltro: 'etapa',
                valor: this.etapaSelected.length == 0 ? [] : this.etapaSelected.map((e) => e.id),
            });
        },
        updateValuePropriedade(value) {
            this.propriedadeSelected = value;

            this.$emit('update-filtro', {
                nomeFiltro: 'propriedade',
                valor: this.propriedadeSelected,
            });

            this.areaSelected = null;
            this.talhoesSelected = [];

            this.areas = [];
            this.talhoes = [];

            this.carregarAreas();
        },
        updateValueArea(value) {
            this.areaSelected = value;

            this.$emit('update-filtro', {
                nomeFiltro: 'area',
                valor: this.areaSelected,
            });

            this.talhoesSelected = [];
            this.talhoes = [];

            this.carregarTalhoes();
        },
        updateValueTalhoes(talhoesSelected) {
            this.talhoesSelected = talhoesSelected;

            this.$emit('update-filtro', {
                nomeFiltro: 'talhoes',
                valor:
                    this.talhoesSelected.length == 0 ? [] : this.talhoesSelected.map((e) => e.id),
            });
        },
        updateValueCultura(value) {
            this.culturaSelected = value;

            this.$emit('update-filtro', {
                nomeFiltro: 'cultura',
                valor: this.culturaSelected,
            });

            this.cultivaresSelected = [];
            this.fasesFenologicasSelected = [];

            this.cultivares = [];
            this.fasesFenologicas = [];

            this.carregarCultivares();
            this.carregarFasesFenologicas();
        },
        updateValueCultivares(cultivaresSelected) {
            this.cultivaresSelected = cultivaresSelected;

            this.$emit('update-filtro', {
                nomeFiltro: 'cultivares',
                valor:
                    this.cultivaresSelected.length == 0
                        ? []
                        : this.cultivaresSelected.map((e) => e.id),
            });
        },
        updateValueFasesFenologicas(fasesFenologicasSelected) {
            this.fasesFenologicasSelected = fasesFenologicasSelected;

            this.$emit('update-filtro', {
                nomeFiltro: 'fasesFenologicas',
                valor:
                    this.fasesFenologicasSelected.length == 0
                        ? []
                        : this.fasesFenologicasSelected.map((e) => e.id),
            });
        },
        updateValueTiposAgroVisitas(tiposDeAgroVisitasSelected) {
            this.tiposDeAgroVisitasSelected = tiposDeAgroVisitasSelected;

            this.assuntosAgroVisitas = [];
            this.assuntosAgroVisitasSelected = [];

            this.$emit('update-filtro', {
                nomeFiltro: 'tiposDeAgroVisitas',
                valor:
                    this.tiposDeAgroVisitasSelected.length == 0
                        ? []
                        : this.tiposDeAgroVisitasSelected.map((e) => e.id),
            });

            this.carregarAssuntosAgroVisitas();
        },
        updateValueAssuntosAgroVisitas(assuntosAgroVisitasSelected) {
            this.assuntosAgroVisitasSelected = assuntosAgroVisitasSelected;

            this.$emit('update-filtro', {
                nomeFiltro: 'assuntosAgroVisitas',
                valor:
                    this.assuntosAgroVisitasSelected.length == 0
                        ? []
                        : this.assuntosAgroVisitasSelected.map((e) => e.id),
            });
        },
        updateValueSafras(safrasSelected) {
            this.safrasSelected = safrasSelected;

            this.$emit('update-filtro', {
                nomeFiltro: 'safras',
                valor: this.safrasSelected.length == 0 ? [] : this.safrasSelected.map((e) => e.id),
            });
        },
        updateDataAtendimento(date) {
            this.datainicial = date;

            this.$emit('update-filtro', {
                nomeFiltro: 'datainicial',
                valor: this.datainicial,
            });
        },
        updateDataFinalizacao(date) {
            this.datafinal = date;

            this.$emit('update-filtro', {
                nomeFiltro: 'datafinal',
                valor: this.datafinal,
            });
        },
        updateValueObservacao(observacao) {
            this.observacao = observacao;

            this.$emit('update-filtro', {
                nomeFiltro: 'observacao',
                valor: this.observacao,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-1{
    padding: 0px 8px 0px 0px !important;
}

.p-0{
    padding: 0px !important;
}



</style>
